import { cx } from '../lib/cx';
import Image from './Image';

export default function Device({
  type = 'iphone',
  wrapperClass,
  wrapperStyle,
  screenClass,
  screenStyle,
  images = [],
  ui,
  horizontal,
  children,
}) {
  const isIphone = type === 'iphone';

  return (
    <div className={cx('device-wrapper', type, wrapperClass)} style={wrapperStyle}>
      <div className={cx('device', isIphone ? 'device-iphone' : 'device-ipad')}>
        {isIphone ? <div className="island" /> : null}
        {isIphone ? <div className="bar" /> : null}
        <div className="buttons">
          <div className="button" />
          <div className="button" />
        </div>
        <div className={cx('buttons', isIphone ? 'right' : 'top')}>
          <div className="button" />
        </div>
        <div className={cx('screen', screenClass)} style={screenStyle}>
          {horizontal ? (
            <div className="horizontal-scroll-element">
              <Image className={horizontal.className} src={horizontal.src} alt="" />
            </div>
          ) : null}
          {ui ? (
            <div className="ui">
              {ui.map((item) => (
                <Image key={`${item.src}-${item.className}`} className={item.className} src={item.src} alt="" />
              ))}
            </div>
          ) : null}
          {images.map((image, index) => (
            <Image key={`${image.src}-${index}`} src={image.src} alt={image.alt || ''} style={image.style} className={image.className} />
          ))}
          {children}
        </div>
      </div>
    </div>
  );
}
